/* gallery-closet.js  renders the My Closet page from window.GLYCloset.
   Overview of lists (?list absent) or a single list's products (?list=<id>).
   Create/rename/delete use the shared .listmodal component (no native prompt/confirm).
   Lists are capped at GLYCloset.MAX_LISTS. */
(function () {
  'use strict';

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    var root = document.querySelector('[data-gly-closet-root]');
    if (!root || !window.GLYCloset) return;
    var C = window.GLYCloset;

    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function money(cents) { var v = (cents || 0) / 100; return '$' + v.toFixed(2).replace(/\.00$/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
    function imgTag(url, cls) { url = url || ''; if (url.indexOf('//') === 0) url = 'https:' + url; return url ? '<img src="' + esc(url) + '" loading="lazy" alt="">' : ''; }
    function plural(n, w) { return n + ' ' + w + (n === 1 ? '' : 's'); }

    function currentListId() { return new URLSearchParams(location.search).get('list'); }

    /* ---- toast ---- */
    var toastEl;
    function toast(msg) {
      if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'gly-closet-toast'; toastEl.style.cssText = 'position:fixed;left:50%;bottom:28px;transform:translateX(-50%) translateY(16px);background:#15120C;color:#fff;padding:14px 24px;border-radius:40px;font-weight:600;font-size:14px;z-index:200;opacity:0;transition:.28s;box-shadow:0 18px 50px rgba(20,16,8,.28);'; document.body.appendChild(toastEl); }
      toastEl.textContent = msg;
      requestAnimationFrame(function () { toastEl.style.opacity = '1'; toastEl.style.transform = 'translateX(-50%) translateY(0)'; });
      clearTimeout(toastEl._t); toastEl._t = setTimeout(function () { toastEl.style.opacity = '0'; toastEl.style.transform = 'translateX(-50%) translateY(16px)'; }, 1800);
    }

    /* ---- modal (reuses the PDP .listmodal component) ---- */
    var lmHost, lmConfirm = null;
    var CLOSE_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>';
    function ensureHost() {
      if (lmHost) return lmHost;
      lmHost = document.createElement('div');
      lmHost.className = 'gly-lm';
      document.body.appendChild(lmHost);
      lmHost.addEventListener('click', function (e) {
        if (e.target.closest('[data-lm-close]')) { closeModal(); return; }
        if (e.target.closest('[data-lm-confirm]') && lmConfirm) { lmConfirm(); }
      });
      lmHost.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && e.target.matches('[data-lm-input]') && lmConfirm) { e.preventDefault(); lmConfirm(); }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && lmHost.classList.contains('is-open')) closeModal(); });
      return lmHost;
    }
    function openModal(inner) {
      var host = ensureHost();
      host.innerHTML = '<div class="scrim" data-lm-close></div><div class="listmodal" role="dialog" aria-modal="true">' + inner + '</div>';
      host.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      return host;
    }
    function closeModal() { if (lmHost) { lmHost.classList.remove('is-open'); lmHost.innerHTML = ''; document.body.style.overflow = ''; lmConfirm = null; } }
    function modalHead(eyebrow, title) {
      return '<div class="listmodal__head"><div><div class="listmodal__eyebrow">' + esc(eyebrow) + '</div><h2 class="listmodal__title">' + esc(title) + '</h2></div>' +
        '<button type="button" class="listmodal__close" data-lm-close aria-label="Close">' + CLOSE_SVG + '</button></div>';
    }
    /* text-input modal for create / rename */
    function openNameModal(o) {
      var host = openModal(modalHead(o.eyebrow, o.title) +
        '<div class="listmodal__create"><input type="text" data-lm-input maxlength="60" placeholder="' + esc(o.placeholder || '') + '" value="' + esc(o.value || '') + '"><button type="button" data-lm-confirm>' + esc(o.confirmLabel) + '</button></div>');
      var input = host.querySelector('[data-lm-input]');
      lmConfirm = function () { var v = (input.value || '').trim(); if (!v) { input.focus(); return; } closeModal(); o.onConfirm(v); };
      if (input) { input.focus(); input.setSelectionRange(input.value.length, input.value.length); }
    }
    /* confirm modal for delete */
    function openConfirmModal(o) {
      openModal(modalHead(o.eyebrow, o.title) +
        '<p class="lm-msg">' + esc(o.message) + '</p>' +
        '<div class="lm-actions"><button type="button" class="lm-btn lm-btn--ghost" data-lm-close>Cancel</button>' +
        '<button type="button" class="lm-btn lm-btn--danger" data-lm-confirm>' + esc(o.confirmLabel) + '</button></div>');
      lmConfirm = function () { closeModal(); o.onConfirm(); };
    }

    /* ---- covers for the overview ---- */
    function coverHtml(list) {
      var imgs = list.items.slice(0, 4);
      if (!imgs.length) return '<div class="lcover lcover--empty"><svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" stroke-linecap="round"><path d="M12 7a2 2 0 1 1 1.4-3.4M12 7v2l8.2 5.6c1 .7.5 2.4-.8 2.4H4.6c-1.3 0-1.8-1.7-.8-2.4L12 9"/></svg></div>';
      var n = Math.min(imgs.length, 4);
      return '<div class="lcover lcover--' + n + '">' + imgs.map(function (it) { return '<div class="lcover__cell">' + imgTag(it.image) + '</div>'; }).join('') + '</div>';
    }

    function renderOverview() {
      var lists = C.getLists();
      var total = lists.reduce(function (s, l) { return s + l.items.length; }, 0);
      var html = '<div class="closet">';
      html += '<div class="closet__head"><div>';
      html += '<div class="closet__eyebrow">The Gallery</div><h1 class="closet__title">My Closet</h1>';
      html += '<p class="closet__sub">' + plural(lists.length, 'list') + ' · ' + plural(total, 'item') + ' saved</p>';
      html += '</div>';
      if (C.canCreateList()) html += '<button type="button" class="closet__new" data-new><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg> New list</button>';
      html += '</div>';

      html += '<div class="lgrid">';
      lists.forEach(function (l) {
        html += '<div class="lcard">';
        html += '<button type="button" class="lcard__open" data-open="' + esc(l.id) + '" aria-label="Open ' + esc(l.name) + '">' + coverHtml(l) + '</button>';
        html += '<div class="lcard__foot"><div class="lcard__info" data-open="' + esc(l.id) + '"><div class="lcard__name">' + esc(l.name) + '</div><div class="lcard__count">' + plural(l.items.length, 'item') + '</div></div>';
        html += '<div class="lcard__acts"><button type="button" data-rename="' + esc(l.id) + '" aria-label="Rename list"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg></button>';
        if (l.id !== 'wishlist') html += '<button type="button" data-delete="' + esc(l.id) + '" aria-label="Delete list"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14"/></svg></button>';
        html += '</div></div></div>';
      });
      if (C.canCreateList()) html += '<button type="button" class="lcard lcard--add" data-new><span class="lcard__addicon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></span><span>Create a new list</span></button>';
      html += '</div>';
      if (!C.canCreateList()) html += '<p class="closet__capnote">You’ve reached the maximum of ' + C.MAX_LISTS + ' lists.</p>';
      html += '</div>';
      root.innerHTML = html;
    }

    function cardHtml(item) {
      var off = item.compareAt && item.compareAt > item.price ? Math.round((1 - item.price / item.compareAt) * 100) : 0;
      var meta = [item.color, item.size ? String(item.size).toUpperCase() : ''].filter(Boolean).join(' · ');
      var url = esc(item.url || '#');
      var html = '<div class="pcard">';
      html += '<div class="pcard__img">';
      html += '<a class="pcard__imglink" href="' + url + '" aria-label="' + esc(item.title) + '">' + imgTag(item.image) + '</a>';
      if (off) html += '<span class="pcard__match">' + off + '% OFF</span>';
      html += '<button type="button" class="pcard__heart" data-remove="' + esc(item.id) + '" aria-label="Remove"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg></button>';
      if (item.handle) html += '<button type="button" class="pcard__quick" data-gly-qv data-handle="' + esc(item.handle) + '">Quick view</button>';
      html += '</div>';
      html += '<div class="pcard__body">';
      html += '<a class="pcard__name" href="' + url + '">' + esc(item.title) + '</a>';
      html += '<div class="pcard__meta"><span>' + esc(meta) + '</span><span class="pcard__pricebox"><span class="pcard__price">' + money(item.price) + '</span>' + (off ? '<span class="pcard__was">' + money(item.compareAt) + '</span>' : '') + '</span></div>';
      html += '<button type="button" class="gly-closet__add" data-addbag="' + esc(item.id) + '"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg> Add to bag</button>';
      html += '</div></div>';
      return html;
    }

    function renderList(id) {
      var list = C.getList(id);
      if (!list) { history.replaceState(null, '', location.pathname); renderOverview(); return; }
      var html = '<div class="closet">';
      html += '<button type="button" class="closet__back" data-back><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg> All lists</button>';
      html += '<div class="closet__head"><div><div class="closet__eyebrow">My Closet</div><h1 class="closet__title">' + esc(list.name) + '</h1><p class="closet__sub">' + plural(list.items.length, 'item') + '</p></div>';
      if (list.items.length) html += '<button type="button" class="closet__new" data-addall><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg> Add all to bag</button>';
      html += '</div>';
      if (!list.items.length) {
        html += '<div class="cempty"><svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" stroke-linecap="round"><path d="M12 7a2 2 0 1 1 1.4-3.4M12 7v2l8.2 5.6c1 .7.5 2.4-.8 2.4H4.6c-1.3 0-1.8-1.7-.8-2.4L12 9"/></svg><h2>This list is empty</h2><p>Browse the shop and tap "Add to My Lists" on anything you love.</p><a class="cta" href="/collections/all">Start shopping</a></div>';
      } else {
        html += '<div class="recgrid">' + list.items.map(cardHtml).join('') + '</div>';
      }
      html += '</div>';
      root.innerHTML = html;
    }

    function render() {
      var id = currentListId();
      if (id) renderList(id); else renderOverview();
    }

    /* ---- events ---- */
    root.addEventListener('click', function (e) {
      var t;
      if ((t = e.target.closest('[data-open]'))) { var oid = t.getAttribute('data-open'); history.replaceState(null, '', '?list=' + encodeURIComponent(oid)); window.scrollTo(0, 0); renderList(oid); return; }
      if (e.target.closest('[data-back]')) { history.replaceState(null, '', location.pathname); window.scrollTo(0, 0); renderOverview(); return; }
      if (e.target.closest('[data-new]')) {
        if (!C.canCreateList()) { toast('You can have up to ' + C.MAX_LISTS + ' lists'); return; }
        openNameModal({ eyebrow: 'Create', title: 'New list', placeholder: 'Name your list (e.g. Vacation)', confirmLabel: 'Create',
          onConfirm: function (name) { if (!C.createList(name)) { toast('You can have up to ' + C.MAX_LISTS + ' lists'); return; } toast('List created'); renderOverview(); } });
        return;
      }
      if ((t = e.target.closest('[data-rename]'))) {
        var rid = t.getAttribute('data-rename'); var rl = C.getList(rid); if (!rl) return;
        openNameModal({ eyebrow: 'Rename', title: 'Rename list', value: rl.name, placeholder: 'List name', confirmLabel: 'Save',
          onConfirm: function (name) { C.renameList(rid, name); render(); } });
        return;
      }
      if ((t = e.target.closest('[data-delete]'))) {
        var did = t.getAttribute('data-delete'); var dl = C.getList(did); if (!dl) return;
        openConfirmModal({ eyebrow: 'Delete', title: 'Delete list', confirmLabel: 'Delete list',
          message: 'Delete “' + dl.name + '” and its ' + plural(dl.items.length, 'saved item') + '? This can’t be undone.',
          onConfirm: function () { C.deleteList(did); toast('List deleted'); renderOverview(); } });
        return;
      }
      if ((t = e.target.closest('[data-remove]'))) { C.removeItemFromList(currentListId(), t.getAttribute('data-remove')); toast('Removed'); renderList(currentListId()); return; }
      if ((t = e.target.closest('[data-addbag]'))) { addBag(t.getAttribute('data-addbag')); return; }
      if ((t = e.target.closest('[data-addall]'))) { addAll(t); return; }
    });

    function addBag(itemId) {
      var list = C.getList(currentListId()); if (!list) return;
      var item = list.items.filter(function (it) { return String(it.id) === String(itemId); })[0];
      if (!item || !item.variantId) { toast('Choose options on the product page'); return; }
      C.addToCart(item.variantId, 1).then(function () { toast('Added to bag'); }).catch(function () { toast('Could not add'); });
    }

    function addAll(btn) {
      var list = C.getList(currentListId()); if (!list) return;
      var addable = list.items.filter(function (it) { return it.variantId; });
      if (!addable.length) { toast('Nothing to add'); return; }
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      Promise.all(addable.map(function (it) { return C.addToCart(it.variantId, 1).catch(function () {}); }))
        .then(function () { window.location.href = '/cart'; });
    }

    document.addEventListener('gly-closet:change', render);
    render();
  });
})();
